import React from 'react'
import { IntlProvider, injectIntl, FormattedMessage } from 'react-intl'

const Confirmation = (props) => {
  const t = id => props.intl.formatMessage({ id })
  const countries = require(`components/locales/countries/${props.intlLocale}`).default
  const country = countries[props.country] || ''

  return (
    <div className='confirmation-wrapper'>
      <table className="confirmation-table">
        <tbody>
          <tr>
            <td><FormattedMessage id="Register.LastName" /></td>
            <th>{props.lastName}</th>
          </tr>
          <tr>
            <td><FormattedMessage id="Register.FirstName" /></td>
            <th>{props.firstName}</th>
          </tr>
          {
            props.email ? (
              <tr>
                <td><FormattedMessage id="Register.Email" /></td>
                <th>{props.email}</th>
              </tr>
            ) : null
          }
          {
            props.phone ? (
              <tr>
                <td><FormattedMessage id="Register.Phone" /></td>
                <th>{props.phone}</th>
              </tr>
            ) : null
          }
          <tr>
            <td><FormattedMessage id="Register.Country" /></td>
            <th>{country}</th>
          </tr>
        </tbody>
      </table>

      <div className="form__message error">
        { props.message.length > 0 &&
          props.message
        }
      </div>

      <div className="form__message">
        { props.fetching &&
          <div className="wrapper">
            <div className="cssload-loader"></div>
          </div>
        }
      </div>

      <br />

      <div>
        <input
          type="submit"
          onClick={props.register}
          className="button button-dark-blue"
          disabled={props.fetching}
          value={t('Confirmation.ActivateMySim')}
        />
      </div>

      <br />

      <div>
        <input
          type="button"
          value={t('Common.Back')}
          className="button"
          disabled={props.fetching}
          onClick={props.backHandler}
        />
      </div>
    </div>
  )
}

export default injectIntl(Confirmation)



// WEBPACK FOOTER //
// ./app/javascript/components/application/auth/confirmation.js